import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=3fed2b14&scoped=true&"
import script from "./VideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=3fed2b14&scoped=true&lang=scss&"
import style1 from "./VideoPlayer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed2b14",
  null
  
)

component.options.__file = "VideoPlayer.vue"
export default component.exports